import { toast } from "react-toastify";
const globalToaster = toast();
export const itemToaster = toast();
export default globalToaster;
